import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { hasDefaultComponent } from "../../../utils/pageModelUtils";
import { TFieldValidationResult, ValidationAbortError } from ".";


export const termsAndConditionsFieldValidations = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    const validationResult: TFieldValidationResult = {};
    const { isTermsAgreed, isTermsValid } = validatingState.getTerms();

    // DevNote: Applicants should not be able to trigger this as the CTA should be disabled when terms are not agreed.
    if (
        hasDefaultComponent('cob-corp-acquisition/components/creditonebank/terms-and-conditions')
        && !(isTermsAgreed && isTermsValid)
    ) {
        validationResult['TermsAndConditions'] = 'RequiredField';
    }

    return validationResult;
};

export const applicationEsignFieldValidations = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    const { isEsignAgreed, isEsignShowing, isEsignLinkValid, isEsignRequired } = validatingState.getEsign();
    
    if (isEsignShowing && !isEsignAgreed) {
        throw new ValidationAbortError(
            'Esign not agreed',
            'processingError'
        )
    }

    if (isEsignRequired && !isEsignLinkValid) {
        throw new ValidationAbortError(
            'Esign State Invalid for submission',
            'processingError',
        );
    }

    return {};
};

export const ConsumerAcknowledgementFieldValidations = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    const validationResult: TFieldValidationResult = {};
    const { isConsumerReportAgreed } = validatingState.getConsumerReport();

    if (
        hasDefaultComponent('cob-corp-acquisition/components/creditonebank/consumer-report')
        && !isConsumerReportAgreed
    ) {
        validationResult['ConsumerAcknowledgement'] = 'RequiredField';
    }

    return validationResult;
};